// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/notification/style/index.less
// module id = 1124
// module chunks = 1